module.exports = __webpack_public_path__ + "static/25th-9a26b8ffeb74c1e7c8b0877ac334fed1.png";